// @ts-nocheck
import { ActionExtended } from "@/_common/interfaces/ActionExtended";
import { ACTIONS } from "@/_config";

export interface EventReducer {
  gameDetails: any;
  groups: any;
  rodeoEvents: any;
  rodeoEventDetails: any;
  pastRodeoEvents: any;
  performances: any;
  performanceDetails: any;
  events: any;
  eventDetails: any;
  riders: any;
  activePerformances: any;
  categorizedPerformances: any;
  categorizedRodeoEvents: any;
  categorizedEventGroups: any;
  eventGroupsLeaderboard: any;
  rodeoLeaderboard: any;
  performanceLeaderboard: any;
  sidebarPerformanceLeaderboard: any;
  sidebarRodeoLeaderboard: any;
  sidebarEventGroupsLeaderboard: any;
  makePickModalApiResponse: any;
  viewPicksModalApiResponse: any;
  statusMsg: any;
  myPickList: any;
  tvImage: any;
}

const initialState: EventReducer = {
  gameDetails: null,
  groups: null,
  rodeoEvents: null,
  rodeoEventDetails: null,
  pastRodeoEvents: null,
  performances: null,
  performanceDetails: null,
  events: null,
  eventDetails: null,
  riders: null,
  activePerformances: null,
  categorizedPerformances: null,
  categorizedRodeoEvents: null,
  categorizedEventGroups: null,
  eventGroupsLeaderboard: null,
  rodeoLeaderboard: null,
  performanceLeaderboard: null,
  sidebarPerformanceLeaderboard: null,
  sidebarRodeoLeaderboard: null,
  sidebarEventGroupsLeaderboard: null,
  makePickModalApiResponse: null,
  viewPicksModalApiResponse: null,
  statusMsg: null,
  myPickList: null,
  tvImage: null,
};

const eventReducer = (state = initialState, action: ActionExtended) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default eventReducer;
